import algoliasearch from 'algoliasearch/lite'
import dayjs from 'dayjs'
import Client from '@/api/client'
import { multiMarketIsEnabled } from '@/market'

export const getValidationState = ({ dirty, validated, valid = null }: Record<string, boolean | null>) => {
  return dirty || validated ? valid : null
}

interface SearchRequestParams {
  facets?: string;
  highlightPostTag: string;
  highlightPreTag: string;
  page: number;
  query: string;
  tagFilters: string;
}

interface SearchRequest {
  indexName: string;
  params: SearchRequestParams;
}

export const configureSearchClient = (id: string, key: string, host?: string) => {
  const algoliaClient = algoliasearch(id, key)
  const apiClient = new Client()
  const proxyHost = host || (
    multiMarketIsEnabled()
      ? (process.env.VUE_APP_API_URL || '').replace(/\/$/, '') + '/algolia/search'
      : undefined
  )
  const customClient = {
    search(requests: Array<SearchRequest>) {
      return apiClient.postUrl(proxyHost as string, {
        data: {
          requests,
          page: requests.map(req => req.params.page)[0] + 1,
        },
      })
    },
  }

  return proxyHost ? customClient : algoliaClient
}

export const formatDate = (date: string) => {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
}

export const adjustExpirationDate = (date: string) => {
  return dayjs(date).add(1, 'second')
}

export const formatDateOrdered = (date: string) => {
  const dateWithoutTimezone = new Date(date).toISOString().slice(0, -1);
  return dayjs(dateWithoutTimezone).format('DD.MM.YYYY HH:mm:ss');
}

export { formatMoney, formatMajorMoney, parseSupplierMajorAmount, subtractMoney } from '@/helpers/money'

type DateTimeObject = { date: string | null; time: string | null }
export const convertDateTime = (dateTimeString: string | null): DateTimeObject => {
  if (dateTimeString === null) {
    return { date: null, time: null }
  }

  const dt = new Date(dateTimeString)
  const date = dt.toISOString().split('T')[0]
  const time = dt.toLocaleTimeString('no-NO', { hour12: false }).replace(/:/g, ':')

  return { date, time }
}
